import { IconCondominium } from 'icons'
import styles from './MultipleBadge.module.scss'

export type TProps = {
  map?: google.maps.Map
  onClick?: (map: google.maps.Map) => void
  count: number
}

const MultipleBadge = ({ map, onClick, count }: TProps) => {
  return (
    <button
      type="button"
      className={styles.ecMultipleBadge}
      onClick={() => {
        if (onClick) onClick(map as google.maps.Map)
      }}
    >
      <IconCondominium
        color="white"
        title={`${count} imóveis nessa localização`}
        height={20}
        width={20}
      />
      {count}un.
    </button>
  )
}

export default MultipleBadge
